export default __webpack_public_path__ + "static/image-10-68186318b0f56b8dfc21fd8f94c46d35.jpg";